import axios from "axios";

const endpoint_url = "/campaignV2/customer/luckyDraw/dropdownList";

const getAvailableLuckyDrawDropdown = (parameters) => {
  return new Promise((resolve, reject) => {
    axios
      .get(endpoint_url, {
        params: {
          limit: parameters.length,
          skip: parameters.start,
          search: parameters.search,
          product_uuid: parameters.product_uuid,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default getAvailableLuckyDrawDropdown;
